export default function LocationZoneStacked(props) {
  const { row, variant = "table", className = "" } = props;
  const locationLabel = row?.location?.label;
  const zoneLabel = row?.zone?.label;
  const empty = !locationLabel && !zoneLabel;

  if (variant === "field") {
    return (
      <div className={`rounded-md bg-gray-50 px-3 py-2 ${className}`}>
        <p className="font-12 block font-medium text-gray-600">Location</p>
        {empty ? (
          <div className="text-base font-medium text-gray-900">—</div>
        ) : (
          <>
            {zoneLabel ? (
              <div className="text-base font-semibold text-gray-900">
                {zoneLabel}
              </div>
            ) : null}
            {locationLabel ? (
              <div className="mt-0.5 text-xs text-gray-500">
                {locationLabel}
              </div>
            ) : null}
          </>
        )}
      </div>
    );
  }

  if (empty) {
    return <span className="text-sm text-[#94A3B8]">—</span>;
  }

  return (
    <div className={`min-w-0 ${className}`}>
      {zoneLabel ? (
        <div className="truncate text-sm font-semibold text-[#0F172A]">
          {zoneLabel}
        </div>
      ) : null}
      {locationLabel ? (
        <div className="truncate text-xs leading-4 text-[#64748B]">
          {locationLabel}
        </div>
      ) : null}
    </div>
  );
}
